/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Error_CameraInputs */



/**
* | output |
* | --- |
* | "Couldn't access the camera." |
*
* @param {Deck_Error_CameraInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_error_camera = /** @type {((inputs?: Deck_Error_CameraInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Error_CameraInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'accéder à la caméra.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo acceder a la cámara.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível acessar a câmera.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile accedere alla fotocamera.")
	return /** @type {LocalizedString} */ ("Couldn't access the camera.")
});